export function autonumeric2toLocaleStringOptions (options) {
    return {
        ...options,
        maximumFractionDigits: options.decimalPlaces,

        // assume that null or undefined are true
        minimumFractionDigits: typeof options.allowDecimalPadding !== 'boolean' ||
            options.allowDecimalPadding ? options.decimalPlaces : 0,
        useGrouping: Boolean(options.digitGroupSeparator)
    };
}
